import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { SectionTitle } from '../common/section_title';
import { ContentCard } from '../common/content_card';
import { ContentTitleText } from '../common/content_title_text';
import { withQuoteFlatten } from '../../products/products/common/with_quote_flatten';

const useStyles = createUseStyles((theme) => ({
    container: {
        marginBottom: theme.spacing[40]
    },
    content: {
        display: 'block',
        '& ul': {
            marginTop: theme.spacing[12],
            display: 'block'
        },
        '& li': {
            listStyleType: 'disc',
            listStylePosition: 'outside',
            marginLeft: theme.spacing[20],
            lineHeight: '2.2rem'
        },
        fontSize: theme.fontSize.md,
        lineHeight: theme.lineHeight.normal,
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey00,
        extend: ({ breakpoint }) => {
            switch (breakpoint) {
                case 'lg':
                case 'md': return {
                    paddingLeft: theme.spacing[16]
                };
                default: return {
                    paddingLeft: '0.4rem'
                };
            }
        }
    },
}));

const _TermsAndDisclaimers = ({ className, config, productDisclaimer }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { id, label } = config;
    return (
        <div id={id} className={classNames('test-policyProduct-termsAndDisclaimers', classes.container, className)}>
            <SectionTitle label={label} />
            <ContentCard>
                <ContentTitleText title="Disclaimer" />
                <div
                    dangerouslySetInnerHTML={{ __html: productDisclaimer }}
                    className={classNames(classes.content)}
                />
            </ContentCard>
        </div>
    );
};

_TermsAndDisclaimers.propTypes = {
    className: PropTypes.string,
    quote: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    productDisclaimer: PropTypes.string.isRequired
};

const TermsAndDisclaimers = withQuoteFlatten(_TermsAndDisclaimers);

export { TermsAndDisclaimers };
